<ng-template #toast>
  <igo-panel
    *ngIf="store.entities$ | async"
    [ngClass]="getClassPanel()"
    [id]="setHeighPanelTabsMode()"
    [title]="
      resultSelected$.value
        ? getTitle(resultSelected$.value)
        : ('toastPanel.title' | translate)
    "
    (click)="onToggleClick($event)"
    tabindex="0"
    (keydown)="handleKeyboardEvent($event)"
  >
    <igo-actionbar
      id="igo-actionbar"
      panelLeftButton
      [store]="actionStore"
      [withIcon]="true"
      [icon]="icon"
      [withTitle]="actionbarMode === 'overlay'"
      [horizontal]="true"
      [mode]="actionbarMode"
    >
    </igo-actionbar>

    <button
      *ngIf="resultSelected$.value"
      mat-icon-button
      igoStopPropagation
      panelLeftButton
      [matTooltip]="
        ((isSelectedResultOutOfView$ | async)
          ? 'toastPanel.zoomOnFeatureTooltipOutOfView'
          : 'toastPanel.zoomOnFeatureTooltip'
        ) | translate
      "
      matTooltipShowDelay="500"
      (click)="zoomTo()"
    >
      <mat-icon
        aria-hidden="false"
        [matBadge]="(isSelectedResultOutOfView$ | async) ? '!' : ''"
        matBadgeColor="accent"
        matBadgeSize="small"
        [matBadgeHidden]="(isSelectedResultOutOfView$ | async) !== true"
        >zoom_in</mat-icon
      >
    </button>

    <button
      *ngIf="hasGeoService()"
      mat-icon-button
      igoStopPropagation
      panelLeftButton
      tooltip-position="below"
      [matTooltip]="
        ((potententialLayerisAdded$ | async)
          ? 'toastPanel.removeLayer'
          : 'toastPanel.addLayer'
        ) | translate
      "
      matTooltipShowDelay="500"
      [color]="(potententialLayerisAdded$ | async) ? 'warn' : ''"
      (click)="handleLayer()"
    >
      <mat-icon>
        {{ (potententialLayerisAdded$ | async) ? 'delete' : 'add' }}
      </mat-icon>
    </button>

    <button
      *ngIf="resultSelected$.value"
      [disabled]="results[0].meta.id === resultSelected$.value.meta.id"
      mat-icon-button
      igoStopPropagation
      panelLeftButton
      [matTooltip]="'toastPanel.previousFeatureTooltip' | translate"
      matTooltipShowDelay="500"
      (click)="previousResult()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button
      *ngIf="resultSelected$.value"
      [disabled]="
        results[results.length - 1].meta.id === resultSelected$.value.meta.id
      "
      mat-icon-button
      igoStopPropagation
      panelRightButton
      [matTooltip]="'toastPanel.nextFeatureTooltip' | translate"
      matTooltipShowDelay="500"
      (click)="nextResult()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>

    <button
      *ngIf="opened && isDesktop()"
      mat-icon-button
      igoStopPropagation
      panelRightButton
      (click)="resizeWindows()"
      [matTooltip]="
        ((this.fullExtent$ | async)
          ? 'toastPanel.standardExtentTooltip'
          : 'toastPanel.fullExtentTooltip'
        ) | translate
      "
      matTooltipShowDelay="500"
    >
      <mat-icon>{{
        fullExtent ? 'collapse_content' : 'expand_content'
      }}</mat-icon>
    </button>
    <button
      mat-icon-button
      igoStopPropagation
      panelRightButton
      (click)="clear()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <div #content class="toast-content">
      <igo-feature-details
        [map]="map"
        *ngIf="resultSelected$.value"
        [feature]="resultSelected$.value.data"
        (htmlDisplayEvent)="setHtmlDisplay($event)"
      >
      </igo-feature-details>

      <igo-search-results
        *ngIf="!resultSelected$.value"
        [map]="map"
        [store]="store"
        [showIcons]="true"
        [withZoomButton]="withZoomButton"
        (resultFocus)="focusResult($event)"
        (resultUnfocus)="unfocusResult($event, true)"
        (resultSelect)="selectResult($event)"
        [tabsMode]="tabsMode"
      >
      </igo-search-results>
    </div>
  </igo-panel>
</ng-template>

<div
  *ngIf="isMobile(); else toast"
  class="swipe-fix"
  (swipeleft)="swipe($event.type)"
  (swiperight)="swipe($event.type)"
  (swipeup)="swipe($event.type)"
  (swipedown)="swipe($event.type)"
>
  <ng-template [ngTemplateOutlet]="toast"></ng-template>
</div>
